import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { COMMERCE } from '@shared/api/endpoints';
import type { StorefrontSummary } from '@tailorcast/shared-types';

export function useStorefrontSummary() {
  return useQuery({
    queryKey: ['storefront', 'summary'],
    queryFn: () => api.get<StorefrontSummary>(COMMERCE.SUMMARY),
  });
}
